import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {

	static instance: PhonePipe;

	constructor() {
		if (!PhonePipe.instance) {
			PhonePipe.instance = this;
		}
	}

	transform(value: string, args?: any): string {
		value = (value || '').padEnd(10, '#');
		return value.substr(0,3) + '-' + value.substr(3,3) + '-' + value.substr(6);
	}

}
